import { useRouter } from 'next/navigation';
import { ROUTES } from '@/routes/constants';
import { BannerProps } from '@/components/atoms/Banner';
import { useTranslation, Trans } from 'react-i18next';

export const useAuthErrorMessages = (): ((errorCode?: string) => BannerProps) => {
  const router = useRouter();
  const { t } = useTranslation();

  const messages: Record<string, BannerProps> = {
    email_exists: {
      type: 'error',
      title: t('Account already exists'),
      text: (
        <Trans>
          <span>
            Please{' '}
            <span style={{ textDecoration: 'underline', cursor: 'pointer' }} onClick={() => router.push(ROUTES.SignIn)}>
              login
            </span>{' '}
            instead
          </span>
        </Trans>
      ),
    },

    invalid_credentials: {
      type: 'error',
      title: t('Incorrect email or password'),
      text: t('Please try again.'),
    },

    not_signed_up: {
      type: 'error',
      title: t('Incorrect email or password'),
      text: t('Please try again.'),
    },

    invalid_token: {
      type: 'error',
      title: t('Reset link has expired'),
      text: t('Please request a new one.'),
    },

    too_many_requests: {
      type: 'error',
      title: t('Too many requests'),
      text: t('Please wait for 5 minutes before trying again.'),
    },
  };

  const defaultError: BannerProps = {
    type: 'error',
    title: t('Something went wrong'),
    text: t('Please try again later.'),
  };

  return (errorCode?: string) => {
    if (errorCode && messages[errorCode]) {
      return messages[errorCode];
    }

    if (errorCode) {
      return {
        type: 'error',
        title: t('Error'),
        text: errorCode,
      };
    }

    return defaultError;
  };
};
